import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../App';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { PRIORITY_OPTIONS } from '../lib/priority';

export const RequestFollowUpForm = ({ request, machineryId, onBack, onDone }) => {
  const [description, setDescription] = useState(request.description || '');
  const [priority, setPriority] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.post(`${API}/maintenance-requests/${request.id}/acknowledge-follow-up`, {
        machinery_id: machineryId,
        description,
        priority: priority || null,
        due_date: dueDate ? new Date(`${dueDate}T23:59:59`).toISOString() : null,
      });
      toast.success('Request acknowledged · follow-up added to the dashboard');
      onDone();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to create follow-up');
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-3" data-testid="ack-follow-up-form">
      <div className="space-y-1">
        <Label htmlFor="ack-fu-desc">Follow-up *</Label>
        <Textarea id="ack-fu-desc" data-testid="ack-follow-up-description" rows={3} required
          value={description} onChange={(e) => setDescription(e.target.value)} />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1">
          <Label htmlFor="ack-fu-priority">Priority</Label>
          <select id="ack-fu-priority" data-testid="ack-follow-up-priority" value={priority}
            onChange={(e) => setPriority(e.target.value)} className="w-full border rounded-md px-2 py-2 text-sm bg-white">
            <option value="">None</option>
            {PRIORITY_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </div>
        <div className="space-y-1">
          <Label htmlFor="ack-fu-due">Due date</Label>
          <Input id="ack-fu-due" type="date" data-testid="ack-follow-up-due" value={dueDate}
            onChange={(e) => setDueDate(e.target.value)} />
        </div>
      </div>
      <div className="flex justify-end gap-2">
        <Button type="button" variant="outline" onClick={onBack} disabled={saving} data-testid="ack-follow-up-back">Back</Button>
        <Button type="submit" disabled={saving || !description.trim()} data-testid="ack-follow-up-submit">
          {saving ? 'Saving…' : 'Acknowledge & create follow-up'}
        </Button>
      </div>
    </form>
  );
};
